import {getAdvancedLinkedinMessages} from '../../..';

export const getAdvancedMessages = (url: string, errors: any, touched: any): string[] => {
  if (errors.filters) {
    return [];
  }
  return getAdvancedLinkedinMessages(url);
};
